<template>
  <div style="width: 100%;height: 100%;overflow: hidden;">
    <top></top>
    <router-view style="height: calc(100% - 60px);overflow: auto;"></router-view>
  </div>
</template>

<script>
  import top from "./top.vue";

  export default {
    components: {
      top
    },
    name: "index",
    data() {
      return {
      };
    },
    mounted() {
    },
    methods: {
    }
  };
</script>

<style>
  .play-drawer::-webkit-scrollbar{
    width: 0!important;
    height: 7px;
    background-color: transparent;
  }
</style>



// WEBPACK FOOTER //
// src/views/layout/layout.vue